import React, { Component } from 'react'
import { connect } from 'react-redux'
import {createAnnouncement } from '../../store/actions/announcements/announcementAction'
import { Redirect } from 'react-router-dom'
import { MDBInput, MDBBtn } from 'mdbreact'

class createAnnouncements extends Component {
 constructor(props) {
     super(props)
 
     this.state = (
          {  title : '',
            content : ''
         },
         { message : ' '}
     )
 }
 
 handleTitleChange = (e) => {
     console.log(e)
     this.setState({title: e.target.value});
 }

 handleContentChange = (e) => {
    console.log(e)
    this.setState({content: e.target.value});
}
 handleSubmit = (e) => {
    // console.log(e)
    e.preventDefault();
    // console.log(this.state)
    this.props.createAnnouncement(this.state)
}


    render() {
        // const { auth } = this.props;
        const { status } = this.props
        // if(!auth.uid) return <Redirect to='/signin' />
        return (
            <div className='m-5 p-5'>
                <div className="container my-5 p-5 m-5">
                    <form onSubmit={this.handleSubmit} className="white">
                        <h5 className="grey-text text-darken-3">Create announcement</h5>
                        <div className="input-field">
                            <label htmlFor="title">Title</label>
                            <MDBInput type="text" id="title" value={this.state.title} onChange={this.handleTitleChange}></MDBInput>
                        </div>
                        <div className="input-field">
                            <label htmlFor="content">Announcement Content</label>
                            <MDBInput className="textarea" id="content" value={this.state.content} onChange={this.handleContentChange} className="materialize-textarea" />
                        </div>
                        <div className="input-field">
                        <MDBBtn type="submit" className="btn pink lighten-1 z-depth-0">create</MDBBtn>
                        </div>
                    </form>
                    <div className="red-text center">
                            { status ? <p>{status} </p> :null }
                                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
         return {
           
             status : state.announcement.status
         }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createAnnouncement : (announcement)=> dispatch(createAnnouncement(announcement))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(createAnnouncements)